import angular from 'angular';
import { MovimentacoesMovimentacaoFormController } from './movimentacoes-movimentacao-form.controller';

export class MovimentacoesMovimentacaoFormComponent implements angular.IComponentOptions {
    static selector = 'movimentacoesMovimentacaoForm';
    static controller = MovimentacoesMovimentacaoFormController;
    static template = require('!!html-loader!./movimentacoes-movimentacao-form.component.html');
    static bindings = {
        model: '=',
        selectedPeriod: '<',
        formRef: '=?',
        disabled: '<?',
        mode: '@?',
        layout: '@?',
        colaboradorFotoUrl: '<?',
        onValidityChange: '&?'
    };
}
